<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import PostalCodeCommercial from '$lib/PageSections/Forms/PostalCodeCommercial/PostalCodeCommercial.svelte';

	import commercialImage from './images/Joseph_Casillo-25_Broad-NYC-01.jpg?w=500';

	let {
		data = null,
		form = null,
		title = 'Commercial Sales Consultation',
		backgroundColor = 'blue',
		id = '',
		focus = null,
		image,
	} = $props();
</script>

<Section {backgroundColor} {id}>
	<h2>{title}</h2>
	{#if image}{@render image()}{:else}
		<Image
			src={commercialImage}
			alt="exterior facade of the 25 Broad Street building in New York City"
			loading="lazy"
			class="no-bleed mb-4 max-w-xl rounded-lg shadow-lg"
		/>
	{/if}
	<PostalCodeCommercial
		{data}
		{form}
		{focus}
		buttonText="SUBMIT"
		buttonTextLead="SUBMIT"
	/>
	<p>
		We value safety and privacy. We will never share, sell, or rent your data to
		third parties not directly related to your purchase or consideration of our
		products. <a href="/privacy-policy">Read our full policy here.</a>
	</p>
</Section>
